import { FC } from 'react';
import { CellProps, Column } from 'react-table';
import ReactTableWrapper from 'components/table/ReactTableWrapper';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'utils/helpers/formatters';
import IReport from 'routes/client/reports/documents/types';

interface IProps {
  data: any;
  totalCount: number;
}

const LogsTable: FC<IProps> = ({ data, totalCount }) => {
  const { t } = useTranslation();

  const columns: Array<Column<IReport>> = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: '',
      accessor: 'offset',
      width: '10%',
    },
    {
      Header: t('reports.actions') || '',
      accessor: 'name',
      width: '65%',
    },
    {
      Header: t('reports.actionDate') || '',
      accessor: 'created_at',
      width: '25%',
      Cell: ({ value }: CellProps<IReport>) => {
        return <>{formatDate(new Date(value), 'dd.mm.YYY hh:ii:ss')}</>;
      },
    },
  ];

  return (
    <ReactTableWrapper<IReport>
      data={data}
      columns={columns}
      totalCount={totalCount}
      hideFilterBar
      className="c-table--expanded"
    />
  );
};

export default LogsTable;
